(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["farlorn-music"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel = document.getElementById('farlorn-music');
  if (!panel) return;
  const audio = panel.querySelector('audio');
  audio.volume = 0.2;
  panel.addEventListener('toggle', () => {
    if (!panel.open) audio.pause();
  });
  document.addEventListener('play', event => {
    if (event.target !== audio && event.target instanceof HTMLMediaElement) audio.pause();
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
